import { Object } from "interfaces/models/inspectionType";
import { useCallback } from "react";
import { useSelector } from "react-redux";
import { RootState } from "redux/store";
import { getDbIdByExternalId } from "utils/forge/viewerData";

const useGetTargetObjectDbIds = () => {
  const { isLoadedExternalId } = useSelector(
    (state: RootState) => state.forgeViewer
  );

  const getDbIdsFromTargetObjects = useCallback(
    (targetObjects: Partial<Object>[] | undefined) => {
      if (!isLoadedExternalId || !targetObjects) {
        return [];
      }

      return targetObjects.map((obj) => getDbIdByExternalId(obj.externalId!));
    },
    [isLoadedExternalId]
  );

  return { getDbIdsFromTargetObjects };
};

export default useGetTargetObjectDbIds;
